'use strict';

var FirebaseArray = require('./FirebaseArray');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');
var KayleeUtil = require('./KayleeUtil');
//var log = require('../log/Log').channel('KayleeRoomApiKeys');

var KayleeRoomApiKeys = {
    fromJson: fromJson,
    getRoomApiKeys: getRoomApiKeys,
};

function fromJson(data) {
    var reqProps = [ '$roomId' ];
    return FirebaseArray.$fromJson(data, 'RoomApiKeys', reqProps, reqProps,
        function(data) { return getRoomApiKeys(data.$roomId); }
    );
}

// Returns a promise that resolves to the RoomApiKeys object when it is loaded.

function getRoomApiKeys(roomId) {
    var key = 'RoomApiKeys: ' + roomId;
    var commands = KayleeCache.get(key);

    if (commands === null) {
        commands = new RoomApiKeys(roomId);
        KayleeCache.put(key, commands);
    }

    return commands;
}

function RoomApiKeys(roomId) {
    this.$nodeType = 'roomApiKeys';
    this.$roomId = roomId;
    FirebaseArray.call(this,
        KayleeBase.app.database().ref('roomApiKeys/' + roomId));
    KayleeUtil.bindPrototypeMethods(RoomApiKeys.prototype,
        this, this.$items);
    this.$items.$self = this;
    return this.$items;
}

RoomApiKeys.prototype = Object.create(FirebaseArray.prototype);
RoomApiKeys.prototype.constructor = RoomApiKeys;

RoomApiKeys.prototype.$toJson = function() {
    return FirebaseArray.prototype.$toJson.call(this,
        [ '$roomId' ], {});
};

RoomApiKeys.prototype.toString = function() {
    return '[RoomApiKeys (' + this.$id + ') (' + this.$items.length  + ' keys)]';
};

RoomApiKeys.prototype.$remove = function(commandId) {
    return this.$ref.child(commandId).set(null);
};

module.exports = KayleeRoomApiKeys;
